import type { TourStep } from '../types';

export const buildingWebsiteSteps: TourStep[] = [
  {
    target: '[data-tour="website-section"]',
    title: 'Your Website Builder',
    content:
      'This is where you build and manage your professional appraiser website. Let\'s walk through customizing it and getting it published.',
    placement: 'bottom',
    route: '/business?tab=website',
  },
  {
    target: '[data-tour="website-url"]',
    title: 'Your Site URL',
    content:
      'You get a free subdomain at yourname.ashlarapp.com. This is generated from your company name — you can also connect a custom domain later.',
    placement: 'bottom',
    route: '/business?tab=website',
  },
  {
    target: '[data-tour="website-theme"]',
    title: 'Customize Your Theme',
    content:
      'Set your brand colors, upload a hero banner image, and configure the footer. Try changing the primary color to match your firm\'s branding.',
    placement: 'right',
    route: '/business?tab=website',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve explored this',
  },
  {
    target: '[data-tour="website-sections"]',
    title: 'Add Content Sections',
    content:
      'Build your site by adding sections — About, Services, Testimonials, Blog, and more. Drag to reorder, and toggle visibility on each section.',
    placement: 'right',
    route: '/business?tab=website',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve seen the sections',
  },
  {
    target: '[data-tour="website-preview"]',
    title: 'Live Preview',
    content:
      'See exactly what visitors will see as you make changes. The preview updates in real time — what you see here is your live site.',
    placement: 'left',
    route: '/business?tab=website',
  },
  {
    target: '[data-tour="website-publish"]',
    title: 'Publish When Ready',
    content:
      'When you\'re happy with how it looks, click Publish to take your site live. You can unpublish anytime to take it offline for maintenance.',
    placement: 'bottom',
    route: '/business?tab=website',
    isActionStep: true,
    spotlightClicks: true,
  },
];
